import React from 'react';

const CouponPattern = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={10}
      height={120}
      viewBox='0 0 10 120'
      fill='none'
      {...props}
    >
      <path
        d='M10 10L-4.37114e-07 -1.90735e-06L10 -2.34446e-06L10 10Z'
        fill='#450B05'
      />
      <path
        d='M-4.37114e-07 20L10 9.99999L10 30L-4.37114e-07 20Z'
        fill='#450B05'
      />
      <path d='M-4.37114e-07 40L10 30L10 50L-4.37114e-07 40Z' fill='#450B05' />
      <path d='M-4.37114e-07 60L10 50L10 70L-4.37114e-07 60Z' fill='#450B05' />
      <path d='M-4.37114e-07 80L10 70L10 90L-4.37114e-07 80Z' fill='#450B05' />
      <path
        d='M-4.37114e-07 100L10 90L10 110L-4.37114e-07 100Z'
        fill='#450B05'
      />
      <path d='M10 110L-4.37114e-07 120L10 120L10 110Z' fill='#450B05' />
    </svg>
  );
};

export default CouponPattern;
